module.exports = __webpack_public_path__ + "img/vip2.0c9ed57b.png";